/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="store_login_unit">{{brandStoreName}}</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="admin_menu_top_unit menu_center">

                <Message v-if="ApivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />

                <form class="form_staff" v-on:submit.prevent="onsubmit">
                    <div class="lavel_staff right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="authorityKbnSet">権限設定</label>
                    </div>
                    <div class="input_staff left_comment" id="authorityKbnSet">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="authorityKbnSet1" type="radio" value=7 v-model.number="staffData[0].authorityKbn">
                            <label class="form-check-label" for="authorityKbnSet1">スタッフ</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="authorityKbnSet2" type="radio" value=4 v-model.number="staffData[0].authorityKbn">
                            <label class="form-check-label" for="authorityKbnSet2">店舗管理者</label>
                        </div>
                        <br>
                        <label id="authorityKbnSet_err1" class="lavel_error_font ">{{validation.authorityKbnResult}}</label>
                    </div>
                    <div class="lavel_staff right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label  for="staff_name">氏名</label>
                    </div>
                    <div class="input_staff left_comment">
                        <input  class="wd240" id="staff_name" name="name" type="text" v-model="staffData[0].staffName"  maxlength="20" /><br>
                        <label id="nameerror" class="lavel_error_font ">{{validation.staffnameReult}}</label>
                    </div>

                    <div class="lavel_staff right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label  for="staff_name_furigana">ふりがな</label>
                    </div>
                    <div class="input_staff left_comment">
                        <input  class="wd240" id="staff_name_furigana" name="namefuri" type="text" v-model="staffData[0].staffNameFurigana"  maxlength="20  " /><br>
                        <label id="namefurierror" class="lavel_error_font ">{{validation.staffnamefuriganaReult}}</label>
                    </div>
                </form>
            </div>
            <div class="btn_submit letter_spa">
                <a href="#" @click.prevent.stop="checkFrom">更新</a>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">スタッフ更新</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>スタッフ更新が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'StaffEdit',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            isLoading:false,
            isInitLoading:true,
            showContent:false,
            validation:{
                staffnameReult: "",
                staffnamefuriganaReult: "",
            },
            staffData: [{ "id": null, "brandId": null, "storeId": null, "staffId": "", "staffName": "", "staffNameFurigana": "","authorityKbn":"" }],
            addFormFlg: true
        }
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    },

    created: function(){
        this.calc();
    },
    methods: {

        calc() {
            // スタッフ情報取得
            var brandId = this.$store.getters['brand/id'];
            var storeId = this.$store.getters['store/id'];
            var pkStaffId = this.$route.params.id;

            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/staff/' + pkStaffId;

            this.$axios
                .get(url)
                .then(response => (this.staffData = response.data.staffData))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params: {brandPath: this.brandPath}}
                        }
                    }

                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

        },
        checkFrom: async function () {

            this.isLoading = true;
            this.addFormFlg = true;

            //エラー内容初期化
            this.clearError();

            //バリデーションチェック(企業コード)
            //必須チェック
            if (!this.staffData[0].staffName) {
                this.validation.staffnameReult = "氏名を入力してください。"
                this.addFormFlg = false;
            }
            if (!this.staffData[0].staffNameFurigana) {
                this.validation.staffnamefuriganaReult = "ふりがなを入力してください。"
                this.addFormFlg = false;
            }
            if(this.staffData[0].authorityKbn == null){
                this.validation.authorityKbnResult="管理者区分を選択してください。"
                this.addFormFlg = false;
            }


            //桁数チェック
            if (String(this.staffData[0].staffName).length > 20 && this.validation.staffnameReult == "") {
                this.validation.staffnameReult = "氏名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if (String(this.staffData[0].staffNameFurigana).length > 20 && this.validation.staffnamefuriganaReult == "") {
                this.validation.staffnamefuriganaReult = "ふりがなは20桁以内で入力してください。"
                this.addFormFlg = false;
            }


            //文字種チェック
            if (this.staffData[0].staffName !== null && !this.checkStrong2(this.staffData[0].staffName) && this.validation.staffnameReult == "") {
                this.validation.staffnameReult = "氏名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if (this.staffData[0].staffNameFurigana !== null && !this.checkStrong6(this.staffData[0].staffNameFurigana) && this.validation.staffnamefuriganaReult == "") {
                this.validation.staffnamefuriganaReult = "ふりがなは全角ひらがな記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.staffData[0].authorityKbn != 7 && this.staffData[0].authorityKbn != 4 ){
                this.validation.authorityKbnResult="管理者区分の値の形式が正しくありません。"
                this.addFormFlg = false;
            }

            // バリデーション
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            if (this.addFormFlg == true) {

                this.brandId = this.$store.getters['brand/id'];
                this.storeId = this.$store.getters['store/id'];
                var pkStaffId = this.$route.params.id;
                var url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId + '/staff/' + pkStaffId + '/update';

                this.ApivalidationMessage = '';
                var apiResponseFlg = true;

                // 企業情報の登録
                await this.$axios
                    .post(url, {
                        staff_name: this.staffData[0].staffName,
                        staff_name_furigana: this.staffData[0].staffNameFurigana,
                        authority_kbn:this.staffData[0].authorityKbn,
                    })
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            } else if (error.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                // API処理判定
                if(apiResponseFlg){
                    this.openModel();
                }
            }

        },
        //全半角英数漢ひらカナ
        checkStrong2:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpace);
            return re.test(inputdata);
        },
        //全角ひらがな
        checkStrong6: function (inputdata) {
            var re = new RegExp(ValidationRule.ZenkakuHiragana);
            return re.test(inputdata);
        },
        clearError: function () {
            //メッセージ初期化
            this.validation.staffnameReult = "";
            this.validation.staffnamefuriganaReult = "";
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({
                name: 'staffList', params: {
                    brandPath: this.brandPath, brandId: this.$store.getters['$brand/id'],
                    storeId: this.$store.getters['$store/id']
                }
            });
        },
        dateFormat() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = ("0" + (nowDate.getMonth() + 1)).slice(-2);
            let day = ("0" + nowDate.getDate()).slice(-2);
            let hours = ("0" + nowDate.getHours()).slice(-2);
            let minutes = ("0" + nowDate.getMinutes()).slice(-2);
            let seconds = ("0" + nowDate.getSeconds()).slice(-2);

            let format_str = 'YYYYMMDDhhmmss'
            format_str = format_str.replace(/YYYY/g, year);
            format_str = format_str.replace(/MM/g, month);
            format_str = format_str.replace(/DD/g, day);
            format_str = format_str.replace(/hh/g, hours);
            format_str = format_str.replace(/mm/g, minutes);
            format_str = format_str.replace(/ss/g, seconds);
            return format_str;
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>